export const contentTypes = {
  IMAGE: 'IMAGE',
  TEXT: 'TEXT',
  LIST_IMAGE: 'LIST_IMAGE',
};
